import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export const useCustomFields = (module) => {
  const [fieldDefs, setFieldDefs] = useState([]);

  useEffect(() => {
    if (module) {
      api.get(`/config/custom-fields?module=${module}`)
        .then(res => setFieldDefs(res.data.filter(f => f.status === 'active')))
        .catch(() => setFieldDefs([]));
    }
  }, [module]);

  return fieldDefs;
};

export const CustomFieldsForm = ({ fields, values, onChange }) => {
  if (!fields || fields.length === 0) return null;

  const handleChange = (fieldName, value) => {
    onChange({ ...values, [fieldName]: value });
  };

  return (
    <div data-testid="custom-fields-form">
      <h3 style={{ fontSize: '13px', fontWeight: 600, marginTop: '16px', marginBottom: '8px', color: 'var(--text-secondary)' }}>Additional Fields</h3>
      <div className="grid grid-cols-2">
        {fields.map(field => (
          <div className="form-group" key={field.id}>
            <label className="form-label">
              {field.field_label} {field.required && '*'}
            </label>
            {field.field_type === 'text' && (
              <input
                type="text"
                className="form-input"
                value={values[field.field_name] || ''}
                onChange={(e) => handleChange(field.field_name, e.target.value)}
                required={field.required}
                data-testid={`cf-${field.field_name}`}
              />
            )}
            {field.field_type === 'number' && (
              <input
                type="number"
                step="any"
                className="form-input"
                value={values[field.field_name] || ''}
                onChange={(e) => handleChange(field.field_name, e.target.value)}
                required={field.required}
                data-testid={`cf-${field.field_name}`}
              />
            )}
            {field.field_type === 'date' && (
              <input
                type="date"
                className="form-input"
                value={values[field.field_name] || ''}
                onChange={(e) => handleChange(field.field_name, e.target.value)}
                required={field.required}
                data-testid={`cf-${field.field_name}`}
              />
            )}
            {field.field_type === 'dropdown' && (
              <select
                className="form-select"
                value={values[field.field_name] || ''}
                onChange={(e) => handleChange(field.field_name, e.target.value)}
                required={field.required}
                data-testid={`cf-${field.field_name}`}
              >
                <option value="">Select...</option>
                {(field.dropdown_options || []).map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            )}
            {field.field_type === 'checkbox' && (
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                <input
                  type="checkbox"
                  checked={values[field.field_name] === true || values[field.field_name] === 'true'}
                  onChange={(e) => handleChange(field.field_name, e.target.checked)}
                  data-testid={`cf-${field.field_name}`}
                />
                <span style={{ fontSize: '13px' }}>{field.field_label}</span>
              </label>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export const CustomFieldsFilter = ({ fields, values, onChange }) => {
  const filterFields = fields.filter(f => f.show_in_filter);
  if (filterFields.length === 0) return null;

  return (
    <>
      {filterFields.map(field => (
        <div className="form-group" key={field.id} style={{ marginBottom: 0 }}>
          {field.field_type === 'dropdown' ? (
            <select
              className="form-select"
              value={values[field.field_name] || ''}
              onChange={(e) => onChange({ ...values, [field.field_name]: e.target.value })}
              data-testid={`filter-cf-${field.field_name}`}
            >
              <option value="">All {field.field_label}</option>
              {(field.dropdown_options || []).map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          ) : (
            <input
              type={field.field_type === 'number' ? 'number' : 'text'}
              className="form-input"
              placeholder={`Filter by ${field.field_label}...`}
              value={values[field.field_name] || ''}
              onChange={(e) => onChange({ ...values, [field.field_name]: e.target.value })}
              data-testid={`filter-cf-${field.field_name}`}
            />
          )}
        </div>
      ))}
    </>
  );
};

export const CustomFieldsDisplay = ({ fields, values }) => {
  const printFields = fields.filter(f => f.show_in_print);
  if (printFields.length === 0 || !values) return null;

  return printFields.map(field => {
    const val = values[field.field_name];
    if (val === undefined || val === null || val === '') return null;
    return (
      <div key={field.id} style={{ marginBottom: '4px' }}>
        <strong>{field.field_label}:</strong> {String(val)}
      </div>
    );
  }).filter(Boolean);
};
